import React, { useState } from 'react';
import { Image } from 'react-bootstrap';
import styles from './../style/PhoneDropdown.module.scss';

const PhoneDropdown = ({ options, userProfileType }) => {
  const [isOpen, setIsOpen] = useState(false);
  
  const phones = options?.phones?.[userProfileType] || [];
  const phoneLabel = userProfileType === 'individual' ? 'Для розничных покупателей' : 'Для оптовых покупателей';
  
  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  if (!phones || phones.length === 0) return (
    <></>
  );

  return (
    <div className={styles.phoneDropdown}>
      <div 
        className={styles.phoneMain}
        onClick={toggleDropdown}
      >
        <Image alt="Телефон" className="me-2" src="/images/phone-in-header.svg" width="14" height="14" />
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          <a href={`tel:` + phones[0].replace(/[-()\s]/g, '')} className={styles.phoneNumber}>
            {phones[0]}
          </a>
          <div className={styles.phoneSubtext}>
            {phoneLabel}
          </div>
        </div>
        <svg 
          width="11" 
          height="6" 
          viewBox="0 0 11 6" 
          fill="none" 
          xmlns="http://www.w3.org/2000/svg" 
          className={`${styles.dropdownIcon} ${isOpen ? styles.dropdownIconOpen : ''}`}
        >
          <path d="M1 1L5.5 5L10 1" stroke="black" strokeWidth="0.75"/>
        </svg>
      </div>

      {isOpen && (
        <div className={styles.dropdownMenu}>
          {userProfileType == `legal` ?
            <div className={styles.dropdownSection}>
              <div className={styles.dropdownSectionHeader}>Оптовая покупка</div>
              {options?.phones?.legal?.map((phone, index) => (
                <React.Fragment key={`legal-${index}`}>
                  <a 
                    href={`tel:` + phone.replace(/[-()\s]/g, '')}
                    className={styles.dropdownPhoneNumber}
                  >
                    {phone}
                  </a>
                </React.Fragment>
              ))}
            </div>
          :
            <div className={styles.dropdownSection}>
              <div className={styles.dropdownSectionHeader}>Розничная покупка</div>
              {options?.phones?.individual?.map((phone, index) => (
                <React.Fragment key={`individual-${index}`}>
                  <a 
                    href={`tel:` + phone.replace(/[-()\s]/g, '')}
                    className={styles.dropdownPhoneNumber}
                  >
                    {phone}
                  </a>
                </React.Fragment>
              ))}
            </div>
          }
          {/* Retail section }
          <div className={styles.dropdownSection}>
            <div className={styles.dropdownSectionHeader}>Розничная покупка</div>
            {options?.phones?.individual?.map((phone, index) => (
              <React.Fragment key={`individual-${index}`}>
                <a 
                  href={`tel:` + phone.replace(/[-()\s]/g, '')}
                  className={styles.dropdownPhoneNumber}
                >
                  {phone}
                </a>
              </React.Fragment>
            ))}
          </div>
          
          <div className={styles.dropdownDivider}></div>
          
          {/* Wholesale section }
          <div className={styles.dropdownSection}>
            <div className={styles.dropdownSectionHeader}>Оптовая покупка</div>
            {options?.phones?.legal?.map((phone, index) => (
              <React.Fragment key={`legal-${index}`}>
                <a 
                  href={`tel:` + phone.replace(/[-()\s]/g, '')}
                  className={styles.dropdownPhoneNumber}
                >
                  {phone}
                </a>
              </React.Fragment>
            ))}
          </div>
          */}
        </div>
      )}
    </div>
  );
};

export default PhoneDropdown;